import { createApp } from 'vue'
import VueGtag from 'vue-gtag-next'
import App from './App.vue'
import i18n from './i18n'
import router from '@/routes'
import store from '@/store'
import getGoogleAnalyticsSettings from './utils/googleAnalytics'
import { init as initFS } from '@fullstory/browser'
import { sanitizeUrl } from '@braintree/sanitize-url'

import clickOutside from './plugins/click-outside'
import { applyStoneRebrandFavicon } from './utils/stone-rebrand-favicon.utils'

import 'emerald-workbench/dist/emerald.jadestone.min.css'

// Jade
import '@stone-payments/jade-design-tokens/stone/bundle.css'

const app = createApp(App)

if (['production'].includes(process.env.VUE_APP_CORE_ENV)) {
  initFS({ orgId: 'BKP05' })

  const googleAnalyticsSettings = getGoogleAnalyticsSettings()
  app.use(VueGtag, googleAnalyticsSettings, router)
}

app.use(router)
app.use(store)
app.use(i18n)
app.config.globalProperties.$sanitize = sanitizeUrl

app.directive('click-outside', clickOutside)

// stone-rebrand: apply the Stone favicon unconditionally
try {
  applyStoneRebrandFavicon()
} catch (error) { /* keep default branding */ }

app.mount('#app')
